const ResetStyle = `
/*==========reset.css==========*/
  h1, h2, h3, h4, h5, h6 {
    clear: both;
    font-weight: 600;
    color: #192029;
    margin: 0.5rem 0;
  }
  html,
  body,
  div,
  span,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  abbr,
  address,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  samp,
  small,
  strong,
  sub,
  sup,
  var,
  b,
  i,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  button {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size:inherit;
    vertical-align: baseline;
    background: transparent;
    font-family: "Noto Sans KR",'Apple SD Gothic Neo', sans-serif;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }
  a {
    margin: 0;
    padding: 0;
    font-size: 15px;
    vertical-align: baseline;
    background: transparent;
    text-decoration: none;
    color: #000;
  }
  a:hover {
    text-decoration: none;
  }
  a:visited {
    color: #4c5161;
  }
  /* change colours to suit your needs */
  ins {
    background-color: #ff9;
    color: #000;
    text-decoration: none;
  }
  /* change colours to suit your needs */
  mark {
    background-color: #ff9;
    color: #000;
    font-style: italic;
    font-weight: bold;
  }
  del {
    text-decoration: line-through;
  }
  abbr[title],
  dfn[title] {
    border-bottom: 1px dotted;
    cursor: help;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* change border colour to suit your needs */
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #cccccc;
    margin: 1em 0;
    padding: 0;
  }
  
  input,
  select {
    vertical-align: middle;
    appearance: none;
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    background: none;
  }
  input::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  
  button {
    border: none;
    outline: none;
    background: none;
    padding: 0;
  }
  button:focus {
    outline: none;
  }
  .wid_1180 {
    max-width: 1180px;
    margin: 0 auto;
  }
  .loader {
    width: 40px;
    padding: 5px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #ccc;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: l3 1s infinite linear;
  }
  @keyframes l3 {to{transform: rotate(1turn)}}
`;
export default ResetStyle;